import type { GivingContentObjectDetail } from 'models';
import { Avatar, Card, Col, DetailsCategoryItem, InformationLineIcon, Row } from 'ui';
import { images } from 'common/utils';

type P = { givingContentObject: GivingContentObjectDetail };

const GivingDetailsCard = ({
  givingContentObject: {
    organization,
    postInCommunities: [community],
  },
}: P) => (
  <Card title={<Card.Title icon={<InformationLineIcon />}>Details</Card.Title>}>
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <DetailsCategoryItem
          category="Organization"
          icon={
            <Avatar
              alt="Organization profile photo"
              fallbackPhoto={images.default.organizationProfilePhoto}
              photo={
                organization.squareLogo?.url ??
                organization.profilePhoto?.url ??
                images.default.organizationProfilePhoto
              }
              size={32}
            />
          }
          name={organization.name}
        />
      </Col>
      <Col>
        <DetailsCategoryItem
          category="Community"
          icon={
            <Avatar
              alt="Community profile photo"
              fallbackPhoto={images.default.communityProfilePhoto}
              photo={community.profilePhoto?.url ?? images.default.communityProfilePhoto}
              size={32}
            />
          }
          name={community.name}
        />
      </Col>
    </Row>
  </Card>
);

export default GivingDetailsCard;
